import { EmployeeTagType } from '../../types'

export const rankingUiProps = (): {
  tagColor: (type: string) => 'cyan' | 'gold' | 'red' | 'orange' | 'yellow' | 'lime' | undefined
  isMainTag: (tag: EmployeeTagType) => boolean
  isPerformanceTag: (tag: EmployeeTagType) => boolean
  isRiskOfLossTag: (tag: EmployeeTagType) => boolean
  isImpactOfLossTag: (tag: EmployeeTagType) => boolean
} => {
  const tagColor = (type: string): 'cyan' | 'gold' | 'red' | 'orange' | 'yellow' | 'lime' | undefined => {
    switch (type) {
      case 'untagged':
        return undefined
      case EmployeeTagType.Top:
        return 'cyan'
      case EmployeeTagType.Low:
      case EmployeeTagType.EntryLevelLow:
        return 'gold'
      case EmployeeTagType.RiskOfLossVeryHigh:
      case EmployeeTagType.ImpactOfLossCritical:
      case EmployeeTagType.Leaver:
        return 'red'
      case EmployeeTagType.RiskOfLossHigh:
      case EmployeeTagType.ImpactOfLossSignificant:
      case EmployeeTagType.Limited:
        return 'orange'
      case EmployeeTagType.RiskOfLossMedium:
      case EmployeeTagType.ImpactOfLossModerate:
        return 'yellow'
      case EmployeeTagType.RiskOfLossLow:
      case EmployeeTagType.ImpactOfLossMinor:
      default:
        return 'lime'
    }
  }

  const isMainTag = (tag: EmployeeTagType): boolean => {
    switch (tag) {
      case EmployeeTagType.Low:
      case EmployeeTagType.EntryLevelLow:
      case EmployeeTagType.Top:
        return true
      default:
        return false
    }
  }

  const isExpertiseTag = (tag: EmployeeTagType): boolean => {
    switch (tag) {
      case EmployeeTagType.Sales:
      case EmployeeTagType.Speaker:
      case EmployeeTagType.Coach:
      case EmployeeTagType.Expert:
        return true
      default:
        return false
    }
  }

  const isPerformanceTag = (tag: EmployeeTagType): boolean => {
    return isMainTag(tag) || isExpertiseTag(tag)
  }

  const isRiskOfLossTag = (tag: EmployeeTagType): boolean => {
    switch (tag) {
      case EmployeeTagType.RiskOfLossVeryHigh:
      case EmployeeTagType.RiskOfLossHigh:
      case EmployeeTagType.RiskOfLossMedium:
      case EmployeeTagType.RiskOfLossLow:
        return true
      default:
        return false
    }
  }

  const isImpactOfLossTag = (tag: EmployeeTagType): boolean => {
    switch (tag) {
      case EmployeeTagType.ImpactOfLossCritical:
      case EmployeeTagType.ImpactOfLossSignificant:
      case EmployeeTagType.ImpactOfLossModerate:
      case EmployeeTagType.ImpactOfLossMinor:
        return true
      default:
        return false
    }
  }

  return { tagColor, isMainTag, isPerformanceTag, isRiskOfLossTag, isImpactOfLossTag }
}
